var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconOpentab(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u30EC\\u30A4\\u30E4\\u30FC_1",
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u30B0\\u30EB\\u30FC\\u30D7_27605",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7_27605"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.5,15.68H4.36V4.55h5.57v-1.85h-5.68c-.96,0-1.73.78-1.73,1.73v11.36c0,.96.78,1.73,1.73,1.74h11.36c.96,0,1.73-.78,1.73-1.74v-5.68h-1.85v5.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "11.55 2.7 11.55 4.55 14.4 4.55 6.69 12.26 7.99 13.57 15.5 6.06 15.5 8.49 17.35 8.49 17.35 2.7 11.55 2.7"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "_\\u9577\\u65B9\\u5F62_16079",
    "data-name": "\\u9577\\u65B9\\u5F62_16079",
    y: 0,
    width: 20,
    height: 20,
    fill: "none"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOpentab);
export default __webpack_public_path__ + "static/media/icon_opentab.e5f51389d95b3c1ae0fd3f50d9afcbf8.svg";
export { ForwardRef as ReactComponent };